import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faCompressAlt,
  faExpandArrowsAlt
} from "@fortawesome/free-solid-svg-icons";

import { faFreeCodeCamp } from "@fortawesome/free-brands-svg-icons";

library.add(faCompressAlt, faExpandArrowsAlt, faFreeCodeCamp);
